import { FormSection } from "@duosoftbg/nacid-components";
import React from "react";
import StudiedSubjectFormFields from "./common/StudiedSubjectFormFields";

const StudiedSubjectFormSection = ({ label = "t.studied.subjects" }) => {
  return (
    <FormSection label={label}>
      <StudiedSubjectFormFields
        baseField={"studiedSubjects"}
        infoText={"m.diplomaGrade.data.info"}
        isSubjectsDataRequired={false}
      />
    </FormSection>
  );
};
export default StudiedSubjectFormSection;
